<form  [formGroup] = "planForm">
  <h1 *ngIf ="mode ==1" mat-dialog-title> Editing {{data.plan_name}}</h1>
  <h1 *ngIf ="mode ==2" mat-dialog-title> Add Plan </h1>


  <div mat-dialog-content  fxLayout.xs="column" style="width:95%; text-align:center" >
  <br>
    <mat-form-field style="width:80%">
        <mat-label>Plan Name:</mat-label>
        <input matInput formControlName = "plan_name">
      </mat-form-field>

      <mat-form-field style="width:80%">
          <mat-label>Plan Family</mat-label>
          <input  matInput formControlName = "plan_family">
      </mat-form-field>

        <mat-form-field style="width:80%">
          <mat-label>Plan Notes:</mat-label>
          <input matInput formControlName = "plan_notes">
        </mat-form-field>



        <mat-card style="width:80%; display: inline-block">
            <mat-card-title>Square Footage</mat-card-title>

            <div class="flex-container-plans">

                <p style="padding-right: 15px"> System 1: </p>
                <div class="flex-section-plans" style="width:100px">
                <mat-form-field style="width:90%">
                  <mat-label>Area: </mat-label>
                  <input matInput formControlName = "hvac_1_area">
                </mat-form-field>
              </div>
              <div class="flex-section-plans" style="width:100px;">
                <mat-form-field style="width:90%">
                  <mat-label>Ceiling Height: </mat-label>
                  <input matInput formControlName = "hvac1_ceil_ht">
                </mat-form-field>
                </div>

                <p style="padding-right: 15px; padding-left: 15px">System 2: </p>
                <div class="flex-section-plans" style="width:100px">
                <mat-form-field style="width:80%">
                  <mat-label>Area: </mat-label>
                  <input matInput formControlName = "hvac_2_area">
                </mat-form-field>
              </div>
              <div class="flex-section-plans" style="width:100px">
                <mat-form-field style="width:80%">
                  <mat-label>Ceiling Height: </mat-label>
                  <input matInput formControlName = "hvac2_ceil_ht">
                </mat-form-field>
                </div>



              </div>

          <br>
          <div class="flex-container-plans">

              <p style="padding-right: 15px"> System 3: </p>
              <div class="flex-section-plans" style="width:100px">
              <mat-form-field style="width:90%">
                <mat-label>Area: </mat-label>
                <input matInput formControlName = "hvac_3_area">
              </mat-form-field>
            </div>
            <div class="flex-section-plans" style="width:100px;">
              <mat-form-field style="width:90%">
                <mat-label>Ceiling Height: </mat-label>
                <input matInput formControlName = "hvac3_ceil_ht">
              </mat-form-field>
              </div>

              <p style="padding-right: 15px; padding-left: 15px">System 4: </p>
              <div class="flex-section-plans" style="width:100px">
              <mat-form-field style="width:80%">
                <mat-label>Area: </mat-label>
                <input matInput formControlName = "hvac_4_area">
              </mat-form-field>
            </div>
            <div class="flex-section-plans" style="width:100px">
              <mat-form-field style="width:80%">
                <mat-label>Ceiling Height: </mat-label>
                <input matInput formControlName = "hvac4_ceil_ht">
              </mat-form-field>
              </div>



            </div>
            <br>
        </mat-card>



        <mat-card style="width:80%; display: inline-block">

            <div class="flex-container-plans">

                <div style="width:20%">
                <mat-form-field style="width:90%">
                  <mat-label>Additional Volume: </mat-label>
                  <input matInput formControlName = "addvol">
                </mat-form-field>
              </div>

                <div style="width:20%">
                <mat-form-field style="width:90%">
                  <mat-label>Envelope Area: </mat-label>
                  <input matInput formControlName = "envelopearea">
                </mat-form-field>
              </div>

              <div style="width:20%;">
                <mat-form-field style="width:90%">
                  <mat-label>Window Area: </mat-label>
                  <input matInput formControlName = "windowarea">
                </mat-form-field>
                </div>

                <div style="width:20%">
                <mat-form-field style="width:80%">
                  <mat-label> Bedrooms </mat-label>
                  <input matInput formControlName = "bedrooms">
                </mat-form-field>
              </div>

                <div style="width:20%">
                <mat-form-field style="width:80%">
                  <mat-label> Bathrooms </mat-label>
                  <input matInput type="number" min="0" step="0.5" formControlName = "bathrooms">
                </mat-form-field>
              </div>

              </div>

        </mat-card>
        <br>

        <div style="width:20%; margin: 30px;">
            <mat-label style="margin: 20px;"> Prelim </mat-label>
            <mat-checkbox formControlName = "base_plan_reviewed"></mat-checkbox>
        </div>

        <div>
          <mat-form-field style="height: 25px;">
            <mat-label> Unit Types </mat-label>
            <mat-select  formControlName = "unittype">
              <mat-option *ngFor = "let item of unittypes" [value] = "item.value">
                {{item.viewValue}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

          <mat-form-field style="width:90%">
            <mat-label>Customer: {{data.customer_name}}</mat-label>
            <input  #custname matInput formControlName = "customer" [matAutocomplete] = "custauto">
         </mat-form-field>

         <mat-autocomplete #custauto = "matAutocomplete" (optionSelected) = "onSelectCustomer($event.option.value)" [displayWith]="displayFunction">
          <mat-option *ngFor="let customer of (customer$ | async)" [value]="customer">
            <span>{{ customer.customer_name}}</span>
          </mat-option>
        </mat-autocomplete>


        <div style="width:100%">
            <mat-form-field style="width:90%">
              <mat-label> Drive Folder ID:  </mat-label>
              <input (change)="updateDriveLink()" matInput formControlName = "drivelink">
            </mat-form-field>
              <span class="tooltiptext"><img src="https://rhassets.s3.amazonaws.com/driveFolder_link_.jpg"/></span>
              <p [hidden]="!drivelink"><a href="https://drive.google.com/drive/u/0/folders/{{drivelink}}" target="_blank">Drive Folder</a></p>

            <mat-form-field style="width:90%; padding-top: 1em;">
              <mat-label>Base Plan</mat-label>
              <input matInput formControlName = "base_plan">
            </mat-form-field>
      </div>




  </div>



  <div  mat-dialog-actions>
    <button mat-button (click)="dialogRef.close()" >Close </button>
    <button *ngIf ="mode ==1" mat-button (click)="save()" [mat-dialog-close]="data" cdkFocusInitial >Save</button>
    <button *ngIf ="mode ==2" mat-button (click)="add()" [mat-dialog-close]="data" cdkFocusInitial >Add </button>
  </div>

  </form>
